import { CopyFilled, QuestionCircleFilled, RedoOutlined, SearchOutlined } from "@ant-design/icons";
import { Avatar, Button, Card, Checkbox, Col, DatePicker, Drawer, Dropdown, Form, Input, InputNumber, Layout, List, Menu, message, Pagination, Popconfirm, Popover, Row, Select, Skeleton, Space, Spin, Switch, Tag, TimePicker, Tooltip, Typography } from 'antd';
import TextArea from "antd/lib/input/TextArea";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import * as CHALLENGES_SERVICES from "api/services/challenges/challenges.services";
import { findLevelsById } from "api/services/levels/levels.services";
import * as ROOMS_SERVICES from "api/services/rooms/rooms.services";
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";
import axios from "axios";
import { resourcesClient } from "common/axios.config";
import { FLAGS, StatusCode, UserRoles } from 'common/enums';
import AppDrawer from 'components/appDrawer';
import { AppNotification } from "components/appNotification";
import AppResult from 'components/appResults';
import CercleChart from "components/barChart/cercleChart";
import Breadcrumbs from 'components/breadcrumbs';
import ChallengeChart from "components/challengeCharts";
import GroupClassesContent from 'components/classroomComponents/GroupClassesContent/GroupClassesContent';
import ClassroomHeader from 'components/classroomComponents/Header/Header';
import NavigationTabs from 'components/classroomComponents/NavigationTabs/NavigationTabs';
import ClassroomSidebar from 'components/classroomComponents/Sidebar/Sidebar';
import { TabType } from 'components/classroomComponents/types';
import CardMenu from 'components/libs/readyToUse/challengerClasse/card/CardMenu';
import CardMenuLoader from 'components/libs/readyToUse/challengerClasse/card/CardMenuLoader';
import AppSelectGroup from 'components/libs/selectGroup';
import H2 from 'components/libs/subtitle';
import H1 from 'components/libs/title';
import { STATUS_CODES } from "http";
import { Moment } from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import CopyToClipboard from "react-copy-to-clipboard";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { studentParser } from 'screens/student/RoomStudent/assets/utils/converters';
import DrawerPublications from 'screens/teacher/components/drawerPublications';
import AppScreen from 'screens/teacher/ScreenWithSidebar';
import { displayDrawerAdsSpecific } from 'store/adventissements';
import { setIsContributionUpdated, setNewInvitationSent } from 'store/app/appSlice';
import { setChatReceiverId, setSelectUserChat, toggleAppChat } from 'store/AppChat/appChat';
import { useFindRoomMutation } from 'store/services/chat';
import { useCreateAdSpecificMutation } from "store/services/teacher/ads.services";
import { Icourses, useGetAllQuizzMutation } from 'store/services/teacher/courses';
import * as CHALLENGE_SERVICES from "../../../api/services/challenges/challenges.services";
import * as TOPICS_SERVICES from "../../../api/services/topics/topics.services";
import ArrowBack from "../../../assets/images/app/arrow_back.svg";
import Delete from "../../../assets/images/app/delete_article.svg";
import StudentAvatar from "../../../assets/images/app/iam_student.svg";
import MessageIcon from "../../../assets/images/app/message_icon.png";
import MoreOptions from "../../../assets/images/app/options_icon.svg";
import IconSearch, { ReactComponent as SearchIcon } from "../../../assets/images/app/search.svg";
import styles from "../../../screens/teacher/Quizz/assets/quiz.module.css";
import DrawerHistorique from '../Calendar/components';
import DrawerAdsCreneauSpecific from '../components/availabilitySpecific/drawer';
import st from "./assets/room.module.css";
import './ClassDetails.css';

const MESSAGE_PREFIX_PARTAGE_RESEAUX_SOCIAUX = "Bonjour ! Rejoins ma classe sur Monamilabert.com en utilisant ce code :";

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;
const { Title, Text } = Typography;

const OrganismClassDetails: React.FC = () => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { userHavingCalendar, userTeachingOrganismClass } = useSelector((state) => state.app);
  const [createAdSpecific, { isLoading: isCreatingCreneau, isError: isErrorCreatingCreneau, isSuccess: isSuccessCreatingCreneau, data: creneauData }] = useCreateAdSpecificMutation();

  const [activeTab, setActiveTab] = useState<TabType>('reservations');
  const [classData, setClassData] = useState<any>();
  const { newInvitationSent } = useSelector((state) => state.app);
  const isContributionUpdated = useSelector((state) => state.app);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingStudents, setLoadingStudents] = useState<boolean>(true);
  const [isCreatingCourse, setIsCreatingCourse] = useState<boolean>(false);
  const [isSendingInvitations, setIsSendingInvitations] = useState<boolean>(false);

  const [filteredStudents, setFilteredStudents] = useState<any>([]);
  const [teacherFilteredStudents, setTeacherFilteredStudents] = useState<any>([]);
  const [filteredInvitationStudents, setFilteredInvitationStudents] = useState<any>([]);
  const [studentsData, setStudentsData] = useState<any>([]);
  const [teacherStudentsData, setTeacherStudentsData] = useState<any>([]);
  const [selectedStudents, setSelectedStudents] = useState<string[]>([]);
  const [selectedInvitationStudents, setSelectedInvitationStudents] = useState<string[]>([]);

  const [findRoom, { data: dataFindRoom, isSuccess }] = useFindRoomMutation();
  const [showAddClasse, setShowAddClasse] = useState<boolean>(false);
  const [showDrawerCreProf, setShowDrawerCreProf] = useState<boolean>(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [isDrawerStudentsVisible, setIsDrawerStudentsVisible] = useState(false);
  const [openDrawerHistorique, setOpenDrawerHistorique] = useState<boolean>(false);
  const [openDrawerPublications, setOpenDrawerPublications] = useState(false);
  const [isDrawerChallengesHistoryVisible, setIsDrawerChallengesHistoryVisible] = useState(false);
  const [showNewCourseDrawer, setShowNewCourseDrawer] = useState(false);
  const [isStudentsInvitationDrawerVisible, setIsStudentsInvitationDrawerVisible] = useState(false);

  const [courseForm] = Form.useForm();

  const [visibleSocialMedia, setVisibleSocialMedia] = useState(false);

  const [publicationData, setPublicationData] = useState<any>();
  const [challenges, setChallenges] = useState([]);
  const [challengesHistory, setChallengesHistory] = useState([]);
  const [filteredChallenges, setFilteredChallenges] = useState([]);
  const [challenge, setChallenge] = useState<any>();
  const [pieData, setPieData] = useState([]);
  const [barData, setBarData] = useState([]);
  const [challengePercentage, setChallengePercentage] = useState<any>();
  const [registredStudents, setRegistredStudents] = useState<any>();
  const [registredStudentsBigOne, setRegistredStudentsBigOne] = useState<any>();

  const [isDrawerChallenge, setIsDrawerChallenge] = useState<boolean>(false);
  const [drawerConfirm, setDrawerConfirm] = useState<boolean>(false);
  const [tempsChallenge, setTempsChallenge] = useState<number>(0);
  const [getAllQuizz, { data, isLoading: isLoadingQuiz, isError }] = useGetAllQuizzMutation();
  const submit = useRef<any>(null);
  const [tempTopic, setTempTopic] = useState<any>();

  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setcurrentPage] = useState<any>(1);
  const [currentQuizPage, setcurrentQuuizPage] = useState<any>(1);
  const [selectedTeacher, setSelectedTeacher] = useState<any>(null);
  const [price, setPrice] = useState<any>();
  const [cost, setCost] = useState<any>();
  const [date, setDate] = useState<Moment | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [teachersList, setTeachersList] = useState<any>([]);

  const refSubmiteBtn = useRef<any>(null);
  const [page, setPages] = useState<any>(1);
  const [totalPages, setTotalPages] = useState<any>(1);

  const [userLevels, setUserLevels] = useState<any[]>([]);
  const [activeStudentId, setActiveStudentId] = useState<string | null>(null);
  const [activeConfirmStudentId, setActiveConfirmStudentId] = useState<string | null>(null);

  const popoverReportRef = useRef<HTMLDivElement>(null);
  const [studentId, setStudentId] = useState();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const [coursePrice, setCoursePrice] = useState<any>();
  const [courseStartingTime, setCourseStartingTime] = useState<any>();
  const [courseEndingTime, setCourseEndingTime] = useState<any>();

  /* Challenge Details Sets */

  const [isDrawerChallengeDetailsVisible, setIsDrawerChallengeDetailsVisible] = useState(false);
  const [challengePieData, setChallengePieData] = useState<any>([]);
  const [challengeBarData, setChallengeBarData] = useState<any>([]);
  const [challengeStudentsData, setChallengeStudentsData] = useState<any>([]);
  const [challengeDetailsPercentage, setChallengeDetailsPercentage] = useState<any>();
  const [quizWithAnswers, setQuizWithAnswers] = useState<any>([]);
  const [challengeDetailsType, setChallengeDetailsType] = useState<string>("");
  const [loadingQuiz, setLoadingQuiz] = useState<boolean>(false);
  const [isFetchingChallengeData, setIsFetchingChallengeData] = useState<boolean>(false);

  /* Challenge Details Sets */

  const filterChallenges = (value: string) => {
    if (value !== undefined) {
      const filtered = value
        ? filteredChallenges.filter((challenge: any) =>
          challenge.title?.toLowerCase().includes(value.toLowerCase())
        )
        : challengesHistory;
      setFilteredChallenges(filtered);
    }
  }

  const handleReserve = () => {
    setShowDrawerCreProf(true);
  };

  const handleSendMessage = () => {
    const findRoomBody = {
      actor1: user?._id,
      actor2: classData?.teacher?._id,
      flag: FLAGS.SINGLE_FLAG,
      instaprof: "",
      type: "",
    };

    findRoom(findRoomBody);
    dispatch(setChatReceiverId(classData?.teacher?._id));
  };

  const handleSendCollectifMessage = () => {
    const findRoomBody = {
      actor1: user?._id,
      actor2: id,
      flag: FLAGS.GROUP_FLAG,
      instaprof: "",
      type: "",
    };

    findRoom(findRoomBody);
    dispatch(setChatReceiverId(id));
  };

  const handleSendOrganismMessage = () => {
    const findRoomBody = {
      actor1: user?._id,
      actor2: classData?.organism?._id,
      flag: FLAGS.SINGLE_FLAG,
      instaprof: "",
      type: "",
    };

    findRoom(findRoomBody);
    dispatch(setChatReceiverId(classData?.organism?._id));
  };

  const handleSendStudentMessage = () => {
    const findRoomBody = {
      actor1: user?._id,
      actor2: studentId,
      flag: FLAGS.SINGLE_FLAG,
      instaprof: "",
      type: "",
    };

    findRoom(findRoomBody);
    dispatch(setChatReceiverId(studentId));
  };

  const fetchPublicationByClass = async (idClasse: string | undefined) => {
    try {
      const response = await ROOMS_SERVICES.fetchPublicationByClass(idClasse, page);
      if (response?.statusCode === StatusCode.OK) {
        setPublicationData(response?.data);
        dispatch(setIsContributionUpdated(false));
      }
    } catch (error: any) { }
  }

  const fetchClasse = useCallback(async (id: string | undefined) => {
    try {
      setLoading(true);
      const response = await ROOMS_SERVICES.findOne(id);
      if (response?.statusCode === StatusCode.OK) {
        setClassData(response.data);
        setStudentsData(response?.data?.registeredStudents);
        setFilteredStudents(response?.data?.registeredStudents);
        setTeacherFilteredStudents(response?.data?.registeredStudents);
        dispatch(setNewInvitationSent(false));
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoading(false);
      setLoadingStudents(false);
    }
  }, []);

  const ReFetchClasse = useCallback(async () => {
    try {
      const response = await ROOMS_SERVICES.findOne(id);
      if (response?.statusCode === StatusCode.OK) {
        setClassData(response.data);
        setStudentsData(response?.data?.registeredStudents);
        setFilteredStudents(response?.data?.registeredStudents);
        dispatch(setNewInvitationSent(false));
      }
    } catch (error: any) {
      console.log(error);
    }
  }, [id]);

  const fetchChallengesByIdClass = useCallback(
    async (id: string | undefined) => {
      try {
        const response = await CHALLENGES_SERVICES.findByIdClasse(id);
        if (response?.statusCode === StatusCode.OK) {
          setChallenge(response?.data);
        }
      } catch (error: any) { }
    },
    []
  );

  const fetchChallengesHistory = useCallback(
    async () => {
      try {
        const response = await CHALLENGES_SERVICES.fetchChallengesHistory(id);
        if (response?.statusCode === StatusCode.OK) {
          setChallengesHistory(response?.data);
          setFilteredChallenges(response?.data);
          setIsDrawerChallengesHistoryVisible(true);
        }
      } catch (error: any) { }
    },
    [id]
  );

  const fetchPieStatsByIdClass = useCallback(async (id: string | undefined) => {
    try {
      const response = await CHALLENGES_SERVICES.getPieStatsByIdClasse(id);
      if (response?.statusCode === StatusCode.OK) {
        const data = response?.data;
        setPieData(response?.data);
      }
    } catch (error: any) { }
  }, []);

  const fetchBarStatsByIdClass = useCallback(async (id: string | undefined) => {
    try {
      const response = await CHALLENGES_SERVICES.getBarStatsByIdClasse(id);
      if (response?.statusCode === StatusCode.OK) {
        const data = response?.data;
        setBarData(
          data?.flatMap((e: any) => [
            { name: e.name, value: e.participation },
            { name: "Stat 2", value: 100 - e.participation }
          ])
        );
        setChallengePercentage(
          data?.flatMap((e: any) => {
            return e.participation
          })
        );
      }
    } catch (error: any) { }
  }, []);

  const fetchClassementByChallenge = useCallback(
    async (id: string | undefined) => {
      try {
        const response = await CHALLENGES_SERVICES.fetchClassementByChallengee(
          id
        );
        if (response?.statusCode === 200) {
          setRegistredStudents(studentParser(response.data));
          setRegistredStudentsBigOne(studentParser(response.data));
        }
      } catch (error: any) { }
    },
    []
  );

  const handleChallengeStatsDisplay = (challenge: any) => {
    if (!challenge) {
      return;
    }
    const data = challenge?.participantsStats;
    setChallengeBarData(
      data?.flatMap((e: any) => [
        { name: e.name, value: e.participation },
        { name: "Stat 2", value: 100 - e.participation }
      ])
    );
    setChallengeDetailsPercentage(
      data?.flatMap((e: any) => {
        return e.participation
      })
    );
    setChallengePieData(challenge?.answersStats);
    setChallengeStudentsData(challenge?.ranking);
    setIsDrawerChallengeDetailsVisible(true);
  }

  const getTeachers = async () => {
    try {
      setIsLoading(true);
      setTeachersList([]);
      const res = await AUTH_SERVICES.getAllTeachers(currentPage);
      if (res?.data) {
        setTeachersList(res.data.result);
        setTotalPages(res.data?.totalPages);
      } else {
        throw new Error("Error");
      }
    } catch (error) { }
    finally {
      setIsLoading(false);
    }
  }

  const getTeacher = async () => {
    try {
      setIsLoading(true);
      setTeachersList([]);
      const res = await AUTH_SERVICES.getTeacher(currentPage, searchValue);
      if (res?.data) {
        setTeachersList(res.data.result);
        setTotalPages(res.data?.totalPages);
      } else {
        throw new Error("Error");
      }
    } catch (error) { }
    finally {
      setIsLoading(false);
    }
  }

  const handleInviteStudent = () => {
    setShowAddClasse(true);
  }

  const handleAddTeacher = () => {
    setIsDrawerVisible(true);
  }

  const handleSearchChange = (e: any) => {
    setSearchValue(e.target.value);
    if (e.target.value.length > 0) {
      const filterTeacher = teachersList.filter((item: any) =>
        item?.teacher.firstname.toLowerCase().includes(e.target.value.toLowerCase()) ||
        item?.teacher.lastname.toLowerCase().includes(e.target.value.toLowerCase()) ||
        item?.teacher.email.toLowerCase().includes(e.target.value.toLowerCase())
      );
      if (filterTeacher.length !== 0) {
        setTeachersList(filterTeacher);
      }
      else {
        console.log("here");
        setcurrentPage(1);
        getTeacher();
      }
    }
    else {
      getTeachers();
    }
  };

  const handleShowHistory = () => {
    setOpenDrawerHistorique(true);
  };

  const handleAddAvailability = () => {
    dispatch(displayDrawerAdsSpecific(true));
  };

  const handleAddPublication = () => {
    setOpenDrawerPublications(true);
  };

  const handleSelectChallenge = (id: string) => {
    fetchPieStatsByIdClass(id);
    fetchBarStatsByIdClass(id);
    fetchClassementByChallenge(id);
  };

  const startChallenge = async () => {
    setIsDrawerChallenge(true);
  };

  const handleShowStudents = () => {
    setIsDrawerStudentsVisible(true);
  }

  const stopChallenge = async (challengeId: string) => {
    try {
      if (user?._id && challengeId) {
        const response = await CHALLENGE_SERVICES.stopChallenge(challengeId, user?._id);
        if (response?.statusCode === StatusCode.CREATED) {
          window.location.reload();
        }
      }
    } catch (error) {
      message.error("Erreur survenue lors de l'arrêt du challenge.");
    }
  };

  const [form] = Form.useForm();

  const filterQuiz = useCallback(async (values: any) => {
    if (values?.levelId === undefined) {
      values.topicId = undefined
      form.setFieldsValue({
        ['topicId']: undefined,
      });
    }
    await getAllQuizz(values);
  }, []);

  const onReset = () => {
    form.resetFields();
    getAllQuizz({
      title: "",
      levelId: "",
      topicId: "",
      status: "",
      self: false,
      page: 1,
      duration: "",
      quizzLevel: ""
    } as Icourses);
  };

  const OnSelectLevel = useCallback(
    async (levelId: any) => {
      if (levelId) {
        const response = await TOPICS_SERVICES.findAll(levelId);
        if (response?.statusCode === StatusCode.OK) {
          setTempTopic(response?.data);
          form.setFieldsValue({
            ['topicId']: undefined,
          });
          //call static get quizz
          getAllQuizz({
            title: form.getFieldValue('title') === undefined ? "" : form.getFieldValue('title'),
            levelId: levelId,
            topicId: "",
            status: "",
            self: false,
            page: currentPage,
            duration: form.getFieldValue('duration') === undefined ? "" : form.getFieldValue('duration'),
            quizzLevel: form.getFieldValue('quizzLevel') === undefined ? "" : form.getFieldValue('quizzLevel')
          } as Icourses);
        }
      }
    },
    [tempTopic]
  );

  const OnSubmitChallengeHandler = (infos: any) => {
    setChallenge(infos);
  };

  const getLevelById = useCallback(async (idLevel: any) => {
    try {
      if (!idLevel) return null;

      const response = await findLevelsById(idLevel);
      if (response.statusCode === StatusCode.OK) {
        return response.data?.title;
      }
    } catch (error) {
      console.error(error);
    }
    return null;
  }, []);

  const handleFilteringStudents = (e: any) => {

    const value = e.target.value.toLowerCase();

    if (value !== undefined) {
      const filtered = value
        ? studentsData.filter((data: any) =>
          data?.student.firstname?.toLowerCase().includes(value) ||
          data?.student.lastname?.toLowerCase().includes(value)
        )
        : studentsData;

      showNewCourseDrawer ? setTeacherFilteredStudents(filtered) : setFilteredStudents(filtered);
    }
  };

  const handleFilteringInvitationStudents = (e: any) => {

    const value = e.target.value.toLowerCase();

    if (value !== undefined) {
      const filtered = value
        ? teacherStudentsData.filter((student: any) =>
          student.firstname?.toLowerCase().includes(value) ||
          student.lastname?.toLowerCase().includes(value)
        )
        : teacherStudentsData;

      setFilteredInvitationStudents(filtered);
    }
  };

  const handleDeleteStudent = async (id: string) => {
    setIsLoading(true);
    try {
      setIsLoading(true);
      const response = await ROOMS_SERVICES.removeStudentFromClass(data?.accessCode, id);
      if (response?.statusCode === StatusCode.OK) {
        setFilteredStudents((prev: any[]) =>
          prev?.filter((data: any) => data?.student._id !== id)
        );
        message.success("Élève supprimé avec succès.");
        setActiveStudentId(null);
        fetchClasse(id);
      }
    } catch (error: any) {
      console.log(error);
      message.warning("Erreur survenue lors de la suppression, merci de réessayer.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    setTimeout(() => {
      if (popoverReportRef.current && !popoverReportRef.current.contains(event.target as Node)) {
        if (activeConfirmStudentId) {
          console.log("Action selected!");
        } else {
          setActiveStudentId(null);
        }
      }
    }, 200);
  };

  const content = (
    <div onClick={(e) => e.stopPropagation()}>
      <div onClick={handleSendStudentMessage} style={{ fontSize: "1em", height: "30px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", gap: "10px", cursor: "pointer" }}><img src={MessageIcon} height={12}></img> Message</div>
      {!classData?.isCollective && <div onClick={() => { setActiveConfirmStudentId(activeStudentId) }} style={{ fontSize: "1em", color: "#F56666", height: "30px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", gap: "10px", cursor: "pointer" }}><img src={Delete} height={12}></img> Supprimer</div>}
    </div>
  );

  const getStudents = async () => {
    setLoadingStudents(true);
    try {
      const students = await AUTH_SERVICES.getTeacherAllStudents(user?._id);
      if (students?.data) {
        setTeacherStudentsData(students?.data?.results);
        /// setTeacherFilteredStudents(students?.data?.results);
        setFilteredInvitationStudents(students?.data?.results);
      } else {
        throw new Error("L'utilisateur n'existe pas");
      }
    } catch (error) { }
    finally {
      setLoadingStudents(false);
    }
  }

  const handleAddNewCourse = () => {
    setShowNewCourseDrawer(true);
    /// getStudents();
  }

  const [studentOverrides, setStudentOverrides] = useState<{
    [key: string]: {
      custom: boolean;
      price?: number;
    };
  }>({});

  const handleToggleCustomPrice = (studentId: string, checked: boolean) => {
    setStudentOverrides((prev) => ({
      ...prev,
      [studentId]: {
        ...prev[studentId],
        custom: checked,
      },
    }));
  };

  const handleCustomPriceChange = (studentId: string, value: number | null) => {
    setStudentOverrides((prev) => ({
      ...prev,
      [studentId]: {
        ...prev[studentId],
        price: value || 0,
      },
    }));
  };

  const handleSelectStudent = (studentId: string, checked: boolean) => {
    setSelectedStudents((prev) => {
      if (checked) {
        return [...prev, studentId];
      } else {
        // remove override too
        setStudentOverrides((prevOverrides) => {
          const copy = { ...prevOverrides };
          delete copy[studentId];
          return copy;
        });

        return prev.filter((id) => id !== studentId);
      }
    });
  };

  const createCourse = async (values: any) => {
    try {
      setIsCreatingCourse(true);

      const startingTime = values.time;
      const duration = values.duration;
      const endingTime = startingTime.clone().add(duration, "hours");

      const formattedStart = startingTime.format("HH:mm");
      const formattedEnd = endingTime.format("HH:mm");

      setCoursePrice(classData?.classType === "OPEN" ? values?.price : classData?.teacherCreditsCost * classData?.teacherCreditsSpent);
      setCourseStartingTime(formattedStart);
      setCourseEndingTime(formattedEnd);

      const courseData = {
        teacherId: user?._id,
        niches: {
          grouplevels: [""],
          date: values.date._d,
          timeRanges: [
            {
              range: [
                {
                  hour: formattedStart,
                },
                {
                  hour: formattedEnd,
                },
              ],
              type: "collectif",
            },
          ],
        },
        "isCollective": true,
        "classeId": id,
      };

      createAdSpecific(courseData);
    }
    catch (error) {
      AppNotification("Erreur survenue lors de la création du cours", "AlbertSad");
      setIsCreatingCourse(false);
    }
  };

  const handleConfirmReservation = async (courseData: any) => {
    try {
      const reservationData = {
        classeId: courseData?.classeId,
        creneauId: courseData?.niches[0]?.idCreneau,
        pricePerStudent: coursePrice,
        range: [courseStartingTime + ":" + courseEndingTime],
        byCredits: false,
        startDate: courseData?.day + "T" + `${courseStartingTime}:00.000Z`,
        teacherId: user?._id
      };

      const response = await axios.post(`${API_RESSOURCES}/advertisements/collective/reservation`, reservationData);

      if (response.status === StatusCode.CREATED) {
        setTimeout(() => {
          if (selectedStudents?.length > 0) {
            inviteStudentsToCourse(courseData);
          }
          else {
            setIsCreatingCourse(false);
          }
        }, 2000);
      } else {
        message.error("Erreur survenue lors de la création du cours");
      }
    } catch (error) {
      message.error("Erreur survenue lors de la création du cours");
    }
  };

  const inviteStudentsToCourse = async (courseData: any) => {
    const studentsPayload = selectedStudents.map((studentId) => {
      const override = studentOverrides[studentId];

      // If custom price enabled AND price exists
      if (override?.custom && override?.price) {
        return {
          studentId,
          price: override.price,
        };
      }

      // Normal price → no custom price field
      return {
        studentId,
      };
    });

    try {
      const response = await AUTH_SERVICES.inviteStudentsToCourse(id!, courseData?.niches[0]?.idCreneau, studentsPayload, user?._id);
      if (response?.statusCode === STATUS_CODES.OK) {
        message.success("Invitation envoyée avec succès");
      } else {
        message.error("Erreur survenue lors de la création du cours");
      }
    } catch (error) { }
    finally {
      setIsCreatingCourse(false);
    }
  }

  const handleSelectedInvitationStudent = (id: string, checked: boolean) => {
    setSelectedInvitationStudents((prev) =>
      checked ? [...prev, id] : prev.filter((s) => s !== id)
    );
  };

  const handleInviteStudentsToClassroom = () => {
    getStudents();
    setIsStudentsInvitationDrawerVisible(true);
  }

  const handleCopy = () => {
    message.success("copié dans le presse-papiers");
    setVisibleSocialMedia(false);
  }

  const handleSendInvitations = async () => {
    if (!selectedInvitationStudents.length) return;

    setIsSendingInvitations(true);

    const results = await Promise.allSettled(
      selectedInvitationStudents.map((studentId) =>
        AUTH_SERVICES.inviteStudentsToClassroom(id!, studentId)
      )
    );

    const successCount = results.filter(
      (r) => r.status === "fulfilled"
    ).length;

    const failCount = results.filter(
      (r) => r.status === "rejected"
    ).length;

    if (successCount === selectedInvitationStudents.length) {
      message.success("Toutes les invitations ont été envoyées");
      setIsStudentsInvitationDrawerVisible(false);
      setSelectedInvitationStudents((prev: any) => {
        return [];
      });
    } else if (successCount > 0) {
      message.warning(
        `${successCount} invitations envoyées, ${failCount} échecs`
      );
    } else {
      message.error("Erreur lors de l'envoi des invitations");
    }

    setIsSendingInvitations(false);
  };

  useEffect(() => {
    if (isSuccessCreatingCreneau) {
      message.success("Cours crée avec succès");
      courseForm.resetFields();
      setSelectedStudents((prev: any) => {
        return [];
      });
      setStudentOverrides((prev: any) => {
        return {};
      });
      setShowNewCourseDrawer(false);

      if (creneauData) {
        handleConfirmReservation(creneauData?.data);
      }
    }
    if (isErrorCreatingCreneau) {
      message.error("un cours avec ce créneau existe déjà !");
    }
  }, [isSuccessCreatingCreneau, isCreatingCreneau, isErrorCreatingCreneau, creneauData]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeConfirmStudentId]);

  useEffect(() => {
    if (!isLoading) {
      setActiveConfirmStudentId(null);
    }
  }, [isLoading]);

  useEffect(() => {
    if (!filteredStudents?.length) return;

    const fetchLevels = async () => {
      const levels = await Promise.all(
        filteredStudents.map(async (data: any) => {
          const levelTitle = await getLevelById(data?.student?.levelId);
          return {
            studentId: data?.student._id,
            level: levelTitle,
          };
        })
      );

      setUserLevels((prev) => [...prev, ...levels]);
    };

    fetchLevels();
  }, [filteredStudents, getLevelById]);

  useEffect(() => {
    fetchClasse(id);
  }, [id]);

  useEffect(() => {
    if (newInvitationSent) {
      fetchClasse(id);
    }
  }, [newInvitationSent]);

  useEffect(() => {
    getTeachers();
  }, [user]);

  useEffect(() => {
    getTeachers();
  }, [currentPage]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(setSelectUserChat(true));
      dispatch(toggleAppChat(true));
    }
  }, [isSuccess]);

  useEffect(() => {
    if (id) {
      fetchClasse(id);
      fetchChallengesByIdClass(id);
    }
  }, [id]);

  useEffect(() => {
    if (id && classData) {
      fetchPublicationByClass(id);
    }
  }, [id, classData]);

  useEffect(() => {
    if (id && classData && isContributionUpdated) {
      fetchPublicationByClass(id);
    }
  }, [id, classData, isContributionUpdated]);

  useEffect(() => {
    if (challenge) {
      fetchPieStatsByIdClass(challenge?._id);
      fetchBarStatsByIdClass(challenge?._id);
      fetchClassementByChallenge(challenge?._id);
    }
  }, [challenge]);

  useEffect(() => {
    if (quizWithAnswers?.length > 0) {
      setIsDrawerChallengeDetailsVisible(true);
    }
  }, [quizWithAnswers]);

  useEffect(() => {
    getAllQuizz({
      title: "",
      levelId: "",
      topicId: "",
      status: "",
      self: false,
      page: currentQuizPage,
      duration: "",
      quizzLevel: ""
    } as Icourses);
    window.scrollTo(0, 0);
  }, [currentQuizPage]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'reservations':
        return (
          !loading && <GroupClassesContent
            data={classData}
            students={filteredStudents}
            viewType="calendarBooking"
            publicationData={publicationData}
            onInviteStudent={handleInviteStudent}
            onShowHistory={handleShowHistory}
            onAddPublication={handleAddPublication}
            onNewAction={ReFetchClasse}
          />
        );
      case 'availability':
        return (
          !loading && <GroupClassesContent
            data={classData}
            students={filteredStudents}
            viewType="calendarTeacher"
            publicationData={publicationData}
            onInviteStudent={handleInviteStudent}
            onShowHistory={handleShowHistory}
            onAddPublication={handleAddPublication}
          />
        );
      case 'publications':
        return (
          !loading && <GroupClassesContent
            data={classData}
            students={filteredStudents}
            viewType="publications"
            publicationData={publicationData}
            onInviteStudent={handleInviteStudent}
            onShowHistory={handleShowHistory}
            onAddPublication={handleAddPublication}
          />
        );
      case 'challenges':
        return (
          !loading && <GroupClassesContent
            data={classData}
            students={filteredStudents}
            viewType="challenges"
            publicationData={publicationData}
            onInviteStudent={handleInviteStudent}
            onShowHistory={handleShowHistory}
            onAddPublication={handleAddPublication}
            onSelectChallenge={handleSelectChallenge}
            pieData={pieData}
            barData={barData}
            challenges={challenges}
            challengePercentage={challengePercentage}
            challengeStudents={registredStudents}
            onDisplayChallengesHistory={fetchChallengesHistory}
          />
        );
      default:
        return null;
    }
  };

  const getQuizWithAnswers = async (idQuiz: string) => {
    setLoadingQuiz(true);
    try {
      const response = await resourcesClient.get(`/quizz/${idQuiz}/withInswers`,
        {
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        }
      );
      if (response) {
        const data = response?.data;
        setQuizWithAnswers(data?.data?.questions);
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoadingQuiz(false);
    }
  };

  const handleSeeChallengeDetails = (challenge: any) => {
    setChallengeDetailsType("dashboard");
    handleChallengeStatsDisplay(challenge);
  };

  const handleSeeChallengeQuiz = (challenge: any) => {
    setChallengeDetailsType("quiz");
    getQuizWithAnswers(challenge?.quizz?._id);
  };

  const menu = (challenge: any) => (
    <Menu>
      <Menu.Item key="dashboard" onClick={() => handleSeeChallengeDetails(challenge)}>
        Dashboard
      </Menu.Item>

      <Menu.Item key="quiz" onClick={() => handleSeeChallengeQuiz(challenge)}>
        Quiz
      </Menu.Item>
    </Menu>
  );

  return (
    <React.Fragment>
      <div style={{ marginTop: isMobile && user?.roles?.includes(UserRoles.TEACHER) ? (!userHavingCalendar || userTeachingOrganismClass) ? "105px" : "70px" : "0px", marginBottom: "7em" }}>
        {!isMobile && <Breadcrumbs isClassroom />}
        <AppScreen>
          <div className="main">
            <div className="content">
              {!loading && <ClassroomHeader data={classData} className={classData?.title} onReserve={handleReserve} onAddAvailability={handleAddAvailability} onAddPublication={handleAddPublication} onAddCourse={handleAddNewCourse} />}
              <div className="main-content">
                <NavigationTabs activeTab={activeTab} onChange={setActiveTab} data={classData}>
                  {renderTabContent()}
                </NavigationTabs>
              </div>
            </div>

            <div className="sidebar">
              <ClassroomSidebar
                data={classData}
                challenge={challenge}
                onSendMessage={handleSendMessage}
                onSendCollectifMessage={handleSendCollectifMessage}
                onSendOrganismMessage={handleSendOrganismMessage}
                onAddTeacher={handleAddTeacher}
                onStartChallenge={startChallenge}
                onStopChallenge={stopChallenge}
                onShowStudents={handleShowStudents}
                onInviteStudents={handleInviteStudentsToClassroom}
              />
            </div>
          </div>

          {/* Drawer Creneau Specific */}
          <DrawerAdsCreneauSpecific isCollective={true} className={classData?.title} classeId={classData?._id} />

          {/* Drawer Publications */}
          <DrawerPublications
            open={openDrawerPublications}
            currRoom={classData}
            setOpen={setOpenDrawerPublications}
            currLevel={classData?.level}
          />

          {/* Add New Challenge */}
          <AppDrawer
            title={<H2>CHALLENGER CETTE CLASSE</H2>}
            headerStyle={{ border: "none" }}
            onClose={() => setIsDrawerChallenge(!isDrawerChallenge)}
            visible={isDrawerChallenge}
          >
            <div className={st.__first_drawer}>
              <div className={st.drawer__content}>

                <Form
                  layout="inline"
                  name="search"
                  autoComplete="off"
                  onFinish={filterQuiz}
                  form={form}
                >
                  <div className={styles.filter}>
                    {!isMobile && <Tooltip placement="left" title={"Réinitialiser tous les filtres"}>
                      <Button
                        className={styles.__reset__btn}
                        onClick={onReset}
                        shape="circle"
                        htmlType="button"
                      >
                        <RedoOutlined />
                      </Button>
                    </Tooltip>}

                    <Row gutter={12}>
                      <div>
                        <div className={styles.filed__search} style={{ marginBottom: isMobile ? "10px" : "0px" }}>
                          <Form.Item name="title" className="searchForm">
                            <Search
                              onChange={() => submit.current.click()}
                              placeholder="Rechercher par mot clé"
                              size="large"
                              bordered={false}
                              style={{ paddingTop: isMobile ? "0px" : "0px" }}
                              enterButton={
                                <button type="submit">
                                  <SearchIcon
                                    style={{
                                      position: "relative",
                                      top: "3px",
                                      left: "10px",
                                    }}
                                  />
                                </button>
                              }
                            />
                          </Form.Item>
                        </div>
                      </div>
                      <div style={{ marginLeft: isMobile ? "0px" : "10px", marginBottom: isMobile ? "10px" : "0px" }}>
                        <div className={`${styles.select}`}>
                          <Form.Item name="levelId">
                            <AppSelectGroup
                              placeholder="Niveau"
                              style={{ width: isMobile ? "100px" : "150px" }}
                              className={styles.inputStyle}
                              onChange={(value: string) => (
                                OnSelectLevel(value)
                              )}
                              onClear={() => (setTempTopic(undefined), submit.current.click())}
                            />
                          </Form.Item>
                        </div>
                      </div>

                      <div style={{ marginLeft: isMobile ? "10px" : "10px", marginBottom: isMobile ? "10px" : "0px" }}>
                        <div className={`${styles.select}`}>
                          <Form.Item name="topicId">
                            <Select
                              placeholder="Matière"
                              allowClear
                              onChange={(value: string) => (
                                submit.current.click()
                              )}
                              bordered={false}
                              style={{ width: isMobile ? "100px" : "150px" }}
                              className={styles.inputStyle}
                            >
                              {tempTopic?.map((topic: any) => (
                                <Option key={topic._id} value={topic._id}>
                                  {topic.title}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>

                      <div style={{ marginLeft: isMobile ? "0px" : "10px", marginBottom: isMobile ? "10px" : "0px" }}>
                        <div className={`${styles.select}`}>
                          <Form.Item name="quizzLevel">
                            <Select
                              onChange={(e: string) => {
                                submit.current.click()
                              }}
                              placeholder="Difficulté"
                              allowClear
                              bordered={false}
                              style={{ width: isMobile ? "100px" : "150px" }}
                              className={styles.inputStyle}
                            >
                              <Option key={"1"} value={"Facile"}>
                                Facile
                              </Option>
                              <Option key={"2"} value={"Moyen"}>
                                Moyen
                              </Option>
                              <Option key={"3"} value={"Difficile"}>
                                Difficile
                              </Option>
                            </Select>
                          </Form.Item>
                        </div>
                      </div>

                      <div style={{ marginLeft: isMobile ? "10px" : "10px", marginBottom: isMobile ? "10px" : "0px" }}>
                        <div className={`${styles.select}`}>
                          <Form.Item name="duration">
                            <Select
                              placeholder="Durée"
                              allowClear
                              bordered={false}
                              onChange={(e: string) => {
                                submit.current.click()
                              }}
                              style={{ width: isMobile ? "100px" : "150px" }}
                              className={styles.inputStyle}
                            >
                              <Option key={"topic._id"} value={"5"}>
                                5 mins
                              </Option>
                              <Option key={"topic._id"} value={"10"}>
                                10 mins
                              </Option>
                              <Option key={"topic._id"} value={"15"}>
                                15 mins
                              </Option>
                              <Option key={"topic._id"} value={"20"}>
                                20 mins
                              </Option>
                              <Option key={"topic._id"} value={"30"}>
                                30 mins
                              </Option>
                              <Option key={"topic._id"} value={"45"}>
                                45 mins
                              </Option>
                            </Select>
                          </Form.Item>
                        </div>
                      </div>

                      {isMobile && <Tooltip placement="bottom" title={"Réinitialiser tous les filtres"}>
                        <Button
                          className={styles.__reset__btn}
                          onClick={onReset}
                          shape="circle"
                          htmlType="button"
                        >
                          <RedoOutlined />
                        </Button>
                      </Tooltip>}
                    </Row>
                  </div>

                  <Button
                    ref={submit}
                    htmlType="submit"
                    className={styles.__submit__hidden}
                  ></Button>
                </Form>
              </div>
              {!isLoadingQuiz ? (
                <>
                  <CardMenu
                    setDrawerConfirm={setDrawerConfirm}
                    setTempsChallenge={setTempsChallenge}
                    data={data?.data}
                    someClasseDataNeeded={classData}
                    handler={OnSubmitChallengeHandler}
                  />
                  <Row justify="center" style={{ marginTop: "2em" }}>
                    <Pagination
                      showSizeChanger={false}
                      onChange={(curr: number) => setcurrentQuuizPage(curr)}
                      defaultCurrent={currentPage}
                      total={data?.data?.count * 10}
                    />
                  </Row>
                </>
              ) : (
                <CardMenuLoader />
              )}
            </div>
          </AppDrawer>

          <AppDrawer
            onClose={() => setDrawerConfirm(false)}
            visible={drawerConfirm}
          >
            <H1>
              Challenge valide pendant {tempsChallenge}{" "}
              {tempsChallenge > 1 ? "heures" : "heure"}{" "}
            </H1>

            <AppResult status="success" title=" Challenge envoyé aux élèves" />
          </AppDrawer>

          {/* Drawer Historique des challenges */}
          <Drawer
            className="drawer"
            placement="right"
            onClose={() => setIsDrawerChallengesHistoryVisible(false)}
            visible={isDrawerChallengesHistoryVisible}
            width={isMobile ? "100%" : "65%"}
            title={
              <div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "row", alignItems: "center", gap: "30px" }}>
                Historique des challenges
                <div className="search-box">
                  <Input
                    placeholder="Chercher ..."
                    onChange={(e) => filterChallenges(e.target.value)}
                    bordered={false}
                    suffix={<img src={IconSearch} height={15} />}
                  />
                </div>
              </div>
            }
            headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
            closeIcon={
              <img
                src={ArrowBack}
                height={isMobile ? 10 : 18}
                style={{}}
              ></img>
            }
            drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "50px", borderBottomLeftRadius: isMobile ? "0px" : "50px", boxShadow: "-3px 3px 34px #39393929" }}
            bodyStyle={{ zIndex: "1" }}
          >
            <div style={{ marginLeft: "5%", marginRight: "5%", }}>
              {filteredChallenges.map((challenge: any) => (
                <div key={challenge?._id} className="challenge-row">
                  <div className="challenge-info">
                    <span className="challenge-title">
                      {challenge?.title}
                    </span>
                    <span className="challenge-date">
                      {new Date(challenge?.createdAt).toLocaleDateString("fr-FR", {
                        weekday: "long",
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </span>
                  </div>

                  <Dropdown overlay={menu(challenge)} trigger={["click"]}>
                    <Button className="classBtn classBtn-teal" loading={loadingQuiz}>
                      Actions
                    </Button>
                  </Dropdown>
                </div>
              ))}
            </div>
          </Drawer>

          {/* Drawer Challenge Details */}
          <Drawer
            className="drawer"
            placement="right"
            onClose={() => setIsDrawerChallengeDetailsVisible(false)}
            visible={isDrawerChallengeDetailsVisible}
            width={isMobile ? "100%" : "65%"}
            title={
              <div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "row", alignItems: "center", gap: "30px" }}>
                Détails du challenge
              </div>
            }
            headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
            closeIcon={
              <img
                src={ArrowBack}
                height={isMobile ? 10 : 18}
                style={{}}
              ></img>
            }
            drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "50px", borderBottomLeftRadius: isMobile ? "0px" : "50px", boxShadow: "-3px 3px 34px #39393929" }}
            bodyStyle={{ zIndex: "1" }}
          >
            {challengeDetailsType === "dashboard" && <div style={{ marginLeft: "5%", marginRight: "5%", }}>
              <div className="group-classes-content">
                <div className="content-header">
                  <Space className="content-header-title-box">
                    <Space className="content-header-title">
                      <Title level={4} style={{ margin: 0 }}>
                        Challenges stats
                      </Title>
                    </Space>
                  </Space>
                </div>

                <div style={{ padding: "10px 20px" }}>
                  {challengePieData && challengePieData.length === 0 ? <div
                    style={{
                      borderRadius: "15px",
                      padding: "0 5%",
                      width: "100%"
                    }}
                  >
                    <AppResult
                      status="info"
                      title={'Aucun challenge en cours !'}
                    />
                  </div> : challengeBarData && challengeBarData.length === 0 ? <div
                    style={{
                      borderRadius: "15px",
                      padding: "0 5%",
                      width: "100%"
                    }}
                  >
                    <AppResult
                      status="info"
                      title={'Aucune donnée reçu pour le moment !'}
                    />
                  </div> : <div className="graphe-left">
                    {/* update statistics dashboard */}

                    <div
                      style={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <div
                        style={{
                          width: "400px",
                          height: "300px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{ fontSize: isMobile ? "0.8em" : "14px" }}
                        >
                          Taux de participation
                        </div>
                        {/* <CercleChart pieData={barData} /> */}
                        <ChallengeChart pieData={challengeBarData} />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "30px",
                          }}
                        >
                          <div style={{ fontSize: isMobile ? "0.8em" : "14px" }}>Participation : {Number(challengeDetailsPercentage) % 1 === 0 ? Number(challengeDetailsPercentage).toFixed(0) : Number(challengeDetailsPercentage).toFixed(2)} %</div>
                        </div>
                      </div>
                      {challengePieData[0]?.total !== 0 && <div
                        style={{
                          width: "400px",
                          height: isMobile ? "auto" : "300px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          fontFamily: "var(--body-font)",
                          marginTop: isMobile ? "20px" : "0px"
                        }}
                      >
                        <div
                          style={{ fontSize: isMobile ? "0.8em" : "14px" }}
                        >
                          Précision moyenne
                        </div>
                        <CercleChart pieData={challengePieData} />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "30px",
                          }}
                        >
                          <div
                            style={{
                              color: "#80b1b2",
                              fontSize: isMobile ? "0.8em" : "14px",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: "10px"
                            }}
                          >
                            Bonne réponse
                            <div style={{ height: "10px", width: "10px", background: "#80b1b2" }}></div>
                          </div>{" "}
                          <div style={{
                            color: "#80b1b2",
                            fontSize: isMobile ? "0.8em" : "14px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: "10px"
                          }}>
                            Mauvaise réponse
                            <div style={{ height: "10px", width: "10px", background: "#b0e0e1" }}></div>
                          </div>
                        </div>
                      </div>}
                    </div>
                  </div>}
                </div>
              </div>

              {challengePieData && challengeBarData && challengeStudentsData && <div className="group-classes-content" style={{ marginTop: 10, paddingBottom: 20 }}>
                <div className="content-header">
                  <Space className="content-header-title-box">
                    <Space className="content-header-title">
                      <Title level={4} style={{ margin: 0 }}>
                        Élèves et classement
                      </Title>
                    </Space>
                  </Space>
                </div>

                {challengeStudentsData && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "90%", height: "auto", margin: "20px auto", paddingLeft: "20px", paddingRight: "20px" }}>
                  <div style={{ width: "45%" }}>
                    Élèves
                  </div>
                  <div style={{ width: "20%" }}>
                    Points
                  </div>
                  <div style={{ width: "20%" }}>
                    classement
                  </div>
                </div>}
                {challengeStudentsData && <div style={{ width: "90%", height: "1px", margin: "0px auto", background: "#C0C0C0", marginBottom: "20px" }}></div>}

                {challengeStudentsData ? challengeStudentsData?.map((student: any, index: number) => {
                  return (
                    <div className="user-challenge-row" key={index}>
                      {/* Left */}
                      <div className="user-info">
                        <img src={student?.profile || StudentAvatar} alt={student?.firstname} className="user-avatar" />
                        <span className="user-name">{student?.firstname + " " + student?.lastname}</span>
                      </div>

                      {/* Center */}
                      <div className="user-stats">
                        <span className="user-stat">{student?.points}</span>
                        <span className="user-stat">{student?.classement}</span>
                      </div>
                    </div>
                  );
                }) : <AppResult status={"info"} title={"Aucun participant."} />}
              </div>}
            </div>}

            {challengeDetailsType === "quiz" && <div style={{ marginLeft: "5%", marginRight: "5%", }}>
              <Title level={4} style={{ marginBottom: 20 }}>
                Quiz du challenge
              </Title>

              <div className="quiz-container">
                {quizWithAnswers?.map((question: any) => (
                  <div key={question._id} className="question-card">
                    {/* Question title */}
                    <div className="question-title">{question.title}</div>

                    {/* Propositions */}
                    <div className="propositions">
                      {question?.propositions?.map((prop: any) => (
                        <div
                          key={prop._id}
                          className="proposition"
                          style={{
                            border: `2px solid ${prop?.isCorrect ? "#2ecc71" : "#e74c3c"}`,
                          }}
                        >
                          {prop.title}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>}
          </Drawer>

          {/* Teacher Courses History */}
          <DrawerHistorique
            open={openDrawerHistorique}
            setOpen={setOpenDrawerHistorique}
          />

          {/* Drawer Students  */}
          <Drawer
            className="drawer"
            placement="right"
            onClose={() => {
              setIsDrawerStudentsVisible(false);
              setActiveStudentId(null);
              setActiveConfirmStudentId(null);
            }}
            visible={isDrawerStudentsVisible}
            width={isMobile ? "100%" : "80%"}
            title={
              <div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "row", alignItems: "center", gap: "30px" }}>
                Mes élèves
                <div className="search-box">
                  <Input
                    placeholder="Chercher ..."
                    onChange={handleFilteringStudents}
                    bordered={false}
                    suffix={<img src={IconSearch} height={15} />}
                  />
                </div>
              </div>
            }
            headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
            closeIcon={
              <img
                src={ArrowBack}
                height={isMobile ? 10 : 18}
                style={{}}
              ></img>
            }
            drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "50px", borderBottomLeftRadius: isMobile ? "0px" : "50px", boxShadow: "-3px 3px 34px #39393929" }}
            bodyStyle={{ zIndex: "1" }}
          >
            <div style={{ marginLeft: "5%", marginRight: "5%", }}>
              {filteredStudents.map((data: any, index: number) => (
                <div key={data?.student?._id} className="student-row">
                  <div className="student-info">
                    <div className="student-info-avatar-name">
                      <img src={data?.student?.profile} height={50} />
                      <span className="student-title">
                        {data?.student?.firstname + " " + data?.student?.lastname}
                      </span>
                    </div>
                    <div className="student-school">{data?.student?.etablissement}</div>
                    <div className="student-level">{userLevels[index]?.level}</div>
                  </div>

                  <Popover
                    className="customPopoverStudent"
                    visible={activeStudentId === data?.student?._id}
                    placement="left"
                    content={content}
                    trigger="click"
                    onVisibleChange={(open) => {
                      if (!open) setActiveStudentId(null);
                    }}
                  >
                    <div ref={popoverReportRef} className="optionButtonStudent" onClick={(e) => {
                      e.stopPropagation();
                      setStudentId(data?.student._id);
                      setActiveStudentId((prev) =>
                        prev === data?.student._id ? null : data?.student._id
                      );
                    }}>
                      <img src={MoreOptions} height={10} style={{ marginRight: "5px" }}></img>
                      Options
                    </div>
                  </Popover>

                  <Popconfirm
                    placement="top"
                    title="Veux-tu vraiment supprimer cet élève ?"
                    visible={activeConfirmStudentId === data?.student?._id}
                    onConfirm={() => {
                      handleDeleteStudent(data?.student._id);
                      setActiveConfirmStudentId(null);
                    }}
                    onCancel={() => setActiveConfirmStudentId(null)}
                    okText={isLoading ? <Spin size="small" /> : "Oui"}
                    cancelText="Non"
                    okButtonProps={{ disabled: isLoading }}
                  >
                    <Button style={{ visibility: "hidden" }}></Button>
                  </Popconfirm>
                </div>
              ))}
            </div>
          </Drawer>

          {/* Drawer New Course  */}
          <Drawer
            className="drawer"
            placement="right"
            onClose={() => {
              setShowNewCourseDrawer(false);
            }}
            visible={showNewCourseDrawer}
            width={isMobile ? "100%" : "65%"}
            title={
              <div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "row", alignItems: "center", gap: "30px" }}>
                Créer un cours
              </div>
            }
            headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
            closeIcon={
              <img
                src={ArrowBack}
                height={isMobile ? 10 : 18}
                style={{}}
              ></img>
            }
            drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "50px", borderBottomLeftRadius: isMobile ? "0px" : "50px", boxShadow: "-3px 3px 34px #39393929" }}
            bodyStyle={{ zIndex: "1" }}
          >
            <div style={{ marginLeft: "5%", marginRight: "5%", }}>
              <Form layout="vertical" form={courseForm} onFinish={createCourse}>
                {/* Date + Heure */}
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="Date"
                      name="date"
                      rules={[{ required: true }]}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        style={{ width: '100%', borderRadius: "8px", height: "40px" }}
                        placeholder="JJ/MM/AAAA"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="Heure"
                      name="time"
                      rules={[{ required: true }]}
                    >
                      <TimePicker
                        format="HH:mm"
                        style={{ width: '100%', borderRadius: "8px", height: "40px" }}
                        placeholder="--:--"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                {/* Durée + Tarif */}
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="Durée (heures)"
                      name="duration"
                      initialValue={1}
                      rules={[{ required: true }]}
                    >
                      <InputNumber min={1} style={{ width: '100%', borderRadius: "8px", height: "40px", paddingTop: "3px" }} />
                    </Form.Item>
                  </Col>

                  {classData?.classType === "OPEN" && <Col span={12}>
                    <Form.Item
                      label="Tarif (€)"
                      name="price"
                      initialValue={30}
                      rules={[{ required: true }]}
                    >
                      <InputNumber min={0} style={{ width: '100%', borderRadius: "8px", height: "40px", paddingTop: "3px" }} />
                    </Form.Item>
                  </Col>}
                </Row>

                {/* Description */}
                <Form.Item label="Description (optionnelle)" name="description">
                  <TextArea
                    rows={4}
                    placeholder="Thèmes abordés, objectifs du cours..."
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>

                {/* Élèves à inviter */}
                {loadingStudents ? <Skeleton /> : !loadingStudents && filteredStudents?.length > 0 && <Form.Item>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", gap: "10px", width: "100%", marginBottom: "20px" }}>
                    <Text strong style={{ fontSize: "16px", color: "#707070" }}>Élèves à inviter*</Text>
                    <Input
                      placeholder="Chercher un élève ..."
                      suffix={<SearchOutlined />}
                      style={{ width: "40%", borderRadius: "20px" }}
                      onChange={handleFilteringStudents}
                    />
                  </div>

                  <List
                    bordered
                    style={{ padding: 12, borderRadius: 12 }}
                    dataSource={filteredStudents}
                    renderItem={(data: any, index: number) => {

                      const override = studentOverrides[data?.student._id] || {
                        custom: false,
                      };

                      return (
                        <List.Item
                          key={index}
                          style={{
                            borderRadius: 12,
                            marginBottom: 12,
                            padding: "12px 16px",
                            border: "1px solid #c5c3c3",
                            display: "flex",
                            flexDirection: "row",
                            gap: 12,
                          }}
                        >
                          {/* TOP ROW */}
                          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>

                            <Checkbox
                              style={{ marginRight: 16 }}
                              checked={selectedStudents.includes(data?.student._id)}
                              onChange={(e) =>
                                handleSelectStudent(data?.student._id, e.target.checked)
                              }
                            />

                            <Avatar
                              size={48}
                              src={data?.student?.profile}
                              style={{ marginRight: 16 }}
                            />

                            <div style={{ width: "30%" }}>
                              <div style={{ fontWeight: 500 }}>
                                {data?.student?.firstname + " " + data?.student?.lastname}
                              </div>
                            </div>

                            <Tag
                              style={{
                                height: 35,
                                width: 100,
                                borderRadius: 10,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#E1E1E1",
                              }}
                            >
                              {userLevels[index]?.level}
                            </Tag>
                          </div>

                          {/* PRICE CONTROL ROW */}
                          {classData?.classType === "OPEN" && <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              width: "60%",
                              gap: 10
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                              <Switch
                                checked={override.custom}
                                onChange={(checked) =>
                                  handleToggleCustomPrice(data?.student._id, checked)
                                }
                              />

                              <span style={{ fontSize: 13 }}>
                                {override.custom ? "Tarif perso" : "Tarif normal"}
                              </span>
                            </div>

                            {override.custom && (
                              <InputNumber
                                min={0}
                                placeholder="Prix (€)"
                                style={{ width: 100, borderRadius: 10 }}
                                value={override.price}
                                onChange={(value) =>
                                  handleCustomPriceChange(data?.student._id, value)
                                }
                                disabled={!selectedStudents.includes(data?.student._id)}
                              />
                            )}
                          </div>}
                        </List.Item>
                      );
                    }}
                  />
                </Form.Item>}

                {/* FOOTER BUTTONS */}
                <div style={footerStyle}>
                  <Button
                    size="large"
                    style={cancelBtnStyle}
                    onClick={() => setShowNewCourseDrawer(false)}
                  >
                    Annuler
                  </Button>

                  <Button
                    type="primary"
                    size="large"
                    style={createBtnStyle}
                    htmlType="submit"
                    disabled={isCreatingCourse}
                    loading={isCreatingCourse}
                  >
                    Créer et inviter les élèves
                  </Button>
                </div>
              </Form>
            </div>
          </Drawer>

          {/* Drawer Invite Students  */}
          <Drawer
            className="drawer"
            placement="right"
            onClose={() => {
              setIsStudentsInvitationDrawerVisible(false);
            }}
            visible={isStudentsInvitationDrawerVisible}
            width={isMobile ? "100%" : "65%"}
            title={
              <div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "row", alignItems: "center", gap: "30px" }}>
                Inviter des élèves
              </div>
            }
            headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
            closeIcon={
              <img
                src={ArrowBack}
                height={isMobile ? 10 : 18}
                style={{}}
              ></img>
            }
            drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "50px", borderBottomLeftRadius: isMobile ? "0px" : "50px", boxShadow: "-3px 3px 34px #39393929" }}
            bodyStyle={{ zIndex: "1" }}
          >
            <div style={{ marginLeft: "5%", marginRight: "5%", }}>
              {/* Class Card */}
              <Card
                style={{
                  background: "#dbeaf7",
                  borderRadius: 6,
                  marginTop: 30,
                  border: "none",
                  padding: 12
                }}
              >
                <Text strong style={{ color: "#155cb0" }}>{classData?.title}</Text>
                <br />
                <Text style={{ color: "#155cb0" }}>Pack prédéfinie</Text>
              </Card>

              {/* New Pack Card */}
              <Card
                style={{
                  background: "#e6f4ea",
                  borderRadius: 6,
                  marginTop: 20,
                  border: "1px solid #b7eb8f",
                  padding: 12
                }}
              >
                <Text strong style={{ color: "#237804" }}>
                  <QuestionCircleFilled style={{ marginRight: 5 }} />
                  Nouveau pack
                </Text>
                <br />
                <Text style={{ color: "#237804" }}>
                  Vous pourrez créer des cours individuels avec des tarifs personnalisés.
                  Les élèves paieront chaque cours séparément.
                </Text>
              </Card>

              {/* Code Card */}
              <Card
                style={{
                  background: "#e6f4ea",
                  borderRadius: 6,
                  marginTop: 20,
                  border: "1px solid #b7eb8f",
                  padding: 12
                }}
              >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", width: "auto" }}>
                  <Text strong style={{ color: "#237804" }}>
                    Code de la classe : {classData?.accessCode}
                  </Text>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                    <Text style={{ color: "#237804" }}>
                      Vous pouvez partager ce code avec vos élèves afin qu'ils puissent rejoindre votre classe.
                    </Text>

                    <CopyToClipboard
                      text={data?.accessCode}
                      onCopy={handleCopy}
                    >
                      <Button
                        icon={<CopyFilled />}
                        className="classBtn classBtn-green"
                        block
                        style={{ width: "auto", fontSize: "1em" }}
                      >
                        Copier
                      </Button>
                    </CopyToClipboard>
                  </div>
                </div>
              </Card>

              {/* Search */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 40,
                  marginBottom: 20,
                  gap: 20,
                }}
              >
                <Text strong style={{ fontSize: "16px", color: "#707070" }}>Élèves à inviter*</Text>

                <Input
                  placeholder="Chercher un élève ..."
                  suffix={<SearchOutlined />}
                  style={{ width: "30%", borderRadius: "20px" }}
                  onChange={handleFilteringInvitationStudents}
                />
              </div>

              {/* Student List Container */}
              <div
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: 16,
                  padding: 20,
                }}
              >
                <List
                  dataSource={filteredInvitationStudents}
                  renderItem={(student: any) => (
                    <List.Item
                      style={{
                        borderRadius: 16,
                        border: "1px solid #e0e0e0",
                        marginBottom: 16,
                        padding: "15px 20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Checkbox
                          checked={selectedInvitationStudents.includes(student?._id)}
                          onChange={(e) =>
                            handleSelectedInvitationStudent(student?._id, e.target.checked)
                          }
                          style={{ marginRight: 20 }}
                        />

                        <Avatar
                          size={50}
                          src={student.profile}
                          style={{ marginRight: 20 }}
                        />

                        <div style={{ flex: 1 }}>
                          <Text strong>
                            {student.firstname} {student.lastname}
                          </Text>
                        </div>

                        <Tag
                          style={{
                            borderRadius: 10,
                            padding: "6px 16px",
                            background: "#f0f0f0",
                            border: "none",
                          }}
                        >
                          {student.level.title}
                        </Tag>
                      </div>
                    </List.Item>
                  )}
                />
              </div>

              {/* FOOTER BUTTONS */}
              <div style={footerStyle}>
                <Button
                  size="large"
                  style={cancelBtnStyle}
                  onClick={() => setIsStudentsInvitationDrawerVisible(false)}
                >
                  Annuler
                </Button>

                <Button
                  type="primary"
                  size="large"
                  style={createBtnStyle}
                  disabled={isSendingInvitations}
                  loading={isSendingInvitations}
                  onClick={handleSendInvitations}
                >
                  Envoyer les invitations
                </Button>
              </div>
            </div>
          </Drawer>
        </AppScreen>
      </div>
    </React.Fragment>
  );
};

export default OrganismClassDetails;

const footerStyle = {
  display: "flex",
  justifyContent: "center",
  gap: 30,
  marginTop: 60,
};

const cancelBtnStyle = {
  width: 200,
  borderRadius: 30,
  height: 40,
  background: "#cfcfcf",
  border: "none",
  boxShadow: "3px 5px 1px -1px #868686",
  webkitBoxShadow: "5px 7px 1px -1px #868686",
  mozBoxShadow: "5px 7px 1px -1px #868686",
};

const createBtnStyle = {
  width: 220,
  borderRadius: 30,
  height: 40,
  background: "#7da7a6",
  border: "none",
  boxShadow: "3px 5px 1px -1px #5a8484",
  webkitBoxShadow: "5px 7px 1px -1px #5a8484",
  mozBoxShadow: "5px 7px 1px -1px #5a8484",
};